import { getSpacing, SpacingName, ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const wrapper: ThemedFunctor = ({ theme }) => css`
  min-width: 18rem;
  padding: ${theme.remSize[150]};
`;

export const dashedLine: ThemedFunctor = ({ theme }) => css`
  border: none;
  border-top: 1px dashed ${theme.palettes.neutrals.light};
  flex-grow: 1;
`;

export const solidDivider: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.margin(theme, [SpacingName.SMALLEST, 0, 0])};
  border: none;
  border-top: 1px solid ${theme.palettes.neutrals.light};
  width: 100%;
`;

export const agentWrapper: ThemedFunctor = () => css`
  max-width: 12rem;
`;
